import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const OpacityValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const OpacityTokenData = tokenAliasOrValue(OpacityValue);

export type OpacityValue = z.infer<typeof OpacityValue>;
export type OpacityTokenData = z.infer<typeof OpacityTokenData>;
